/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.1
 */
import styled from 'styled-components';

import { colors } from '../../../../theme';

const HorizontalSeparateLineStyled = styled.div.attrs({
    className: 'range-date-picker__calendar-head-horizontal-line',
})`
    content: " ";
    position: absolute;
    width: 224px;
    border-bottom: 1px solid ${colors.borderColorNormal};
    opacity: .2;
`;

export {
    HorizontalSeparateLineStyled,
};
